<udex-message-strip *ngIf="isOpen" (close)="closeMessage()" class="udex-mb-32" design="Negative" status-type="Icon">
  <p>
    {{ 'checkout.error.backEndCall.message' | cxTranslate }}
    <udex-link class="d-inline" (click)="refreshPage()" (keydown.enter)="refreshPage()"
               data-cy="refresh-page-button">{{ 'checkout.error.backEndCall.refreshPage' | cxTranslate }}
    </udex-link>
    {{ 'checkout.error.backEndCall.message1' | cxTranslate }}
    <udex-link class="d-inline" (click)="dcpSupportFormService.open()" (keydown.enter)="dcpSupportFormService.open()"
               data-cy="contact-support-link">{{ 'checkout.error.backEndCall.contactSupport' | cxTranslate }}
    </udex-link>
  </p>
</udex-message-strip>
